import {
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  TextField,
} from "@mui/material";
import React from "react";
import { toEnglish } from "../../../scripts/functions";

const ModiInfo = ({ data, setData, err, setError }) => {
  return (
    <div className="flex errorInput relative z-[55555]  flex-col gap-4 mt-10 ">
      <fieldset className="border-2 loginTab border-[#fff] relative z-50 px-4 py-4 md:py-9 rounded-md">
        <legend className="px-3 text-white md:px-9 text-center font-bold text-lg">
          مشخصات نماینده
        </legend>
        <div className="sm:grid lg:grid-cols-4 md:grid-cols-3 sm:grid-cols-2 flex flex-col gap-7 pb-2">
          <div className="flex bg-white rounded-md gap-2 items-center pr-2 pl-1">
            <small className="min-w-max"> کد ملی</small>
            <TextField
              fullWidth
              variant="outlined"
              type={"number"}
              value={data?.chNationalCode || ""}
              onChange={(e) => {
                setData({ ...data, chNationalCode: e.target.value });
                if (err?.chNationalCode !== undefined) {
                  if (e.target.value) {
                    setError({ ...err, chNationalCode: false });
                  } else {
                    setError({ ...err, chNationalCode: true });
                  }
                }
                if (e.target.value.length !== 10) {
                  setError({ ...err, chNationalCodeValid: true });
                } else {
                  setError({ ...err, chNationalCodeValid: false });
                }
              }}
              inputProps={{ maxLength: 10 }}
              error={err?.chNationalCode || err?.chNationalCodeValid}
              helperText={
                err?.chNationalCode
                  ? "این فیلد ضروری است"
                  : err?.chNationalCodeValid
                  ? "کد ملی نامعتبر است"
                  : ""
              }
            />{" "}
          </div>
          <div className="flex bg-white rounded-md gap-2 items-center pr-2 pl-1">
            <small className="min-w-max"> تلفن همراه</small>
            <TextField
              fullWidth
              variant="outlined"
              type={"number"}
              value={data?.chMobile || ""}
              onChange={(e) => {
                if (e.target.value.length < 12) {
                  setData({ ...data, chMobile: e.target.value });
                  if (err?.chMobile !== undefined) {
                    if (e.target.value) {
                      setError({ ...err, chMobile: false });
                    } else {
                      setError({ ...err, chMobile: true });
                    }
                  }
                  if (e.target.value.length < 10) {
                    setError({ ...err, chMobileValid: true });
                  } else {
                    setError({ ...err, chMobileValid: false });
                  }
                }
              }}
              inputProps={{ maxLength: 11 }}
              error={err?.chMobile || err?.chMobileValid}
              helperText={
                err?.chMobile
                  ? "این فیلد ضروری است"
                  : err?.chMobileValid
                  ? "تلفن همراه نامعتبر است"
                  : ""
              }
            />{" "}
          </div>

          <div
            style={{ borderColor: err?.tintSexType ? "red" : "#0000003b" }}
            className="flex bg-white rounded-md gap-2 items-center pr-2 pl-1"
          >
            <small className="min-w-max"> جنسیت : </small>
            <FormControl
              sx={{
                ".MuiTypography-root": {
                  fontSize: "13px !important",
                },
              }}
            >
              <RadioGroup aria-labelledby="tintSexType" name="tintSexType" row>
                <FormControlLabel
                  onChange={(e) => {
                    setData({ ...data, tintSexType: 1 });
                    setError({ ...err, tintSexType: false });
                  }}
                  control={
                    <Radio size="small" checked={data?.tintSexType === 1} />
                  }
                  label=" مرد"
                />
                <FormControlLabel
                  onChange={(e) => {
                    setData({ ...data, tintSexType: 2 });
                    setError({ ...err, tintSexType: false });
                  }}
                  control={
                    <Radio size="small" checked={data?.tintSexType === 2} />
                  }
                  label=" زن"
                />
              </RadioGroup>
            </FormControl>
          </div>
          <div className="flex bg-white rounded-md gap-2 items-center pr-2 pl-1">
            <small className="min-w-max">نام</small>
            <TextField
              fullWidth
              variant="outlined"
              value={data?.chFirstName || ""}
              onChange={(e) => {
                setData({ ...data, chFirstName: e.target.value });
                if (err?.chFirstName !== undefined) {
                  if (e.target.value) {
                    setError({ ...err, chFirstName: false });
                  } else {
                    setError({ ...err, chFirstName: true });
                  }
                }
              }}
              error={err?.chFirstName}
              helperText={err?.chFirstName ? "این فیلد ضروری است" : ""}
            />{" "}
          </div>
          <div className="flex bg-white rounded-md gap-2 items-center pr-2 pl-1">
            <small className="min-w-max"> نام خانوادگی</small>
            <TextField
              fullWidth
              variant="outlined"
              value={data?.chLastName || ""}
              onChange={(e) => {
                setData({ ...data, chLastName: e.target.value });
                if (err?.chLastName !== undefined) {
                  if (e.target.value) {
                    setError({ ...err, chLastName: false });
                  } else {
                    setError({ ...err, chLastName: true });
                  }
                }
              }}
              error={err?.chLastName}
              helperText={err?.chLastName ? "این فیلد ضروری است" : ""}
            />{" "}
          </div>
          <div className="flex bg-white rounded-md gap-2 items-center pr-2 pl-1">
            <small className="min-w-max">سمت شغلی</small>
            <TextField
              fullWidth
              variant="outlined"
              value={data?.chJobTitle || ""}
              onChange={(e) => {
                setData({ ...data, chJobTitle: e.target.value });
                if (err?.chJobTitle !== undefined) {
                  if (e.target.value) {
                    setError({ ...err, chJobTitle: false });
                  } else {
                    setError({ ...err, chJobTitle: true });
                  }
                }
              }}
              error={err?.chJobTitle}
              helperText={err?.chJobTitle ? "این فیلد ضروری است" : ""}
            />{" "}
          </div>
          <div className="flex bg-white rounded-md gap-2 col-span-4 items-center pr-2 pl-1">
            <div className="col-span-4">
              <small className="min-w-max"> آدرس مرکزی</small>
              <TextField
                fullWidth
                variant="outlined"
                value={data?.chAddress || ""}
                onChange={(e) => {
                  setData({ ...data, chAddress: e.target.value });
                  if (err?.chAddress !== undefined) {
                    if (e.target.value) {
                      setError({ ...err, chAddress: false });
                    } else {
                      setError({ ...err, chAddress: true });
                    }
                  }
                }}
                error={err?.chAddress}
                helperText={err?.chAddress ? "این فیلد ضروری است" : ""}
              />{" "}
            </div>{" "}
          </div>
        </div>
      </fieldset>
      <fieldset className="border-2 loginTab border-[#fff] px-4 py-4 md:py-9 rounded-md">
        <legend className="px-3 md:px-9 text-[#fff] text-center font-bold text-lg">
          مشخصات مودی
        </legend>
        <div className="sm:grid lg:grid-cols-4 md:grid-cols-3 sm:grid-cols-2 flex flex-col md:gap-5 gap-7 pb-4">
          <div className="flex bg-white rounded-md gap-2 items-center pr-2 pl-1">
            <small className="min-w-max"> عنوان شرکت</small>
            <TextField
              fullWidth
              variant="outlined"
              value={data?.chStateName}
              onChange={(e) =>
                setData({ ...data, chStateName: e.target.value })
              }
              error={err?.chStateName}
              helperText={err?.chStateName ? "این فیلد ضروری است" : ""}
            />
          </div>
          <div className="flex bg-white rounded-md gap-2 items-center pr-2 pl-1">
            <small className="min-w-max"> نوع مودی:‌</small>

            <FormControl
              sx={{
                ".MuiTypography-root": {
                  fontSize: "12px !important",
                },
              }}
            >
              <RadioGroup
                aria-labelledby="chRegisterTypeCode"
                name="chRegisterTypeCode"
                row
              >
                <FormControlLabel
                  onChange={(e) => {
                    setData({ ...data, chRegisterTypeCode: "Legal" });
                    setError({ ...err, chRegisterTypeCode: false });
                  }}
                  control={
                    <Radio
                      size="small"
                      checked={data?.chRegisterTypeCode === "Legal"}
                    />
                  }
                  label=" مودی حقوقی"
                />
                <FormControlLabel
                  onChange={(e) => {
                    setData({ ...data, chRegisterTypeCode: "Real" });
                    setError({ ...err, chRegisterTypeCode: false });
                  }}
                  control={
                    <Radio
                      size="small"
                      checked={data?.chRegisterTypeCode === "Real"}
                    />
                  }
                  label=" مودی حقیقی"
                />
              </RadioGroup>
            </FormControl>
          </div>{" "}
          <div className="flex bg-white rounded-md gap-2 items-center pr-2 pl-1">
            <small className="min-w-max">
              {" "}
              {data?.chRegisterTypeCode === "Real" ? "کد" : "شناسه"} ملی
            </small>
            <TextField
              fullWidth
              type={"number"}
              variant="outlined"
              value={data?.chNationalID || ""}
              onChange={(e) => {
                if (e.target.value.length < 11) {
                  setData({ ...data, chNationalID: toEnglish(e.target.value) });
                }
              }}
              error={err?.chNationalID}
              helperText={err?.chNationalID ? "این فیلد ضروری است" : ""}
            />{" "}
          </div>
          <div className="flex bg-white rounded-md gap-2 items-center pr-2 pl-1">
            <small className="min-w-max"> تلفن شرکت </small>

            <TextField
              fullWidth
              type={"number"}
              variant="outlined"
              value={data?.chTel || ""}
              onChange={(e) =>
                setData({ ...data, chTel: toEnglish(e.target.value) })
              }
              error={err?.chTel}
              helperText={err?.chTel ? "این فیلد ضروری است" : ""}
            />
          </div>
          <div className="lg:col-span-4 md:col-span-3 sm:col-span-2"></div>{" "}
          <div className="lg:col-span-4 md:col-span-3 sm:col-span-2">
            <div className="flex bg-white rounded-md gap-2 items-center pr-2 pl-1">
              <small className="min-w-max"> توضیحات </small>

              <TextField
                fullWidth
                variant="outlined"
                multiline
                rows={2}
                error={err?.chComment}
                helperText={err?.chComment ? "این فیلد ضروری است" : ""}
                value={data?.chComment || ""}
                onChange={(e) =>
                  setData({ ...data, chComment: e.target.value })
                }
              />
            </div>
          </div>
        </div>
      </fieldset>
    </div>
  );
};

export default ModiInfo;
